<template>
    <div>
        <div class="container detail-vertical-distance">
            <div :class="this.isTableMissing && 'detail-alignment'">
                <div class="row">
                    <div class="details-title col-md-6">
                        <div id="detailTitle" class="title-color" :style="{ '--color' : details.non_repeat.titleColor}"
                             v-html="details.non_repeat.title"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="title-color col-md-6" :style="{ '--color' : details.non_repeat.textColor}">
                        <div id="detailDescription" v-html="details.non_repeat.text" class="details-text"></div>
                    </div>
                </div>
                <div class="row" v-if="this.isTableMissing">
                    <img id="detailImage" :data-src="details.non_repeat.tariffImage.general"
                         class="details-image hidden-xs lazy">
                    <img id="detailImage" :data-src="details.non_repeat.tariffImage.mobile"
                         class="details-image visible-xs lazy">
                </div>
                <template v-else>
                    <feature-matrix-table
                        :tabs="tabs"
                        :rows="rows"
                        :lang="lang"
                    ></feature-matrix-table>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import FeatureMatrixTable from "./FeatureMatrixTable.vue";

export default {
    name: "detailsSection",
    props: ['details', 'lang'],
    components: {FeatureMatrixTable},
    data() {
        const {matrix_column_tabs, slices} = this.details.non_repeat.feature_matrix_data;
        return {
            tabs: matrix_column_tabs,
            rows: slices,
            isMobile: window.matchMedia('(max-width: 767px)').matches,
            isTableMissing: this.details.non_repeat.feature_matrix_data.length === 0,
        }
    },
}
</script>

<style scoped>
@media (min-width: 992px) {
    .detail-vertical-distance {
        margin-top: 120px;
    }
    .detail-alignment {
        margin-left: 168px;
    }
}
</style>
